const PUBLISHER = {
  "@type": "Organization",
  name: "MH Cockpit",
  logo: {
    "@type": "ImageObject",
    url: "https://mhcockpit.com/MH_Cockpit_TM_LOGO_transparent.png",
  },
};

const UPLOAD_DATE = "2026-06-01T00:00:00+05:30";
const LOGO_URL =
  "https://mhcockpit.com/MH_Cockpit_TM_LOGO_transparent.png";

function watchAction(target) {
  return { "@type": "WatchAction", target };
}

function trainingVideo({
  name,
  description,
  thumbnailUrl,
  contentUrl,
  embedUrl,
}) {
  return {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    name,
    description,
    thumbnailUrl: [thumbnailUrl],
    uploadDate: UPLOAD_DATE,
    contentUrl,
    embedUrl,
    publisher: PUBLISHER,
    potentialAction: watchAction(embedUrl),
    isFamilyFriendly: true,
    inLanguage: "en-IN",
  };
}

export const videoSchemas = {
  "/": {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    name: "MH Cockpit Aviation Training Overview",
    description:
      "Discover MH Cockpit's aviation training programs, flight simulator facilities, pilot training courses, aviation degree programs, and career opportunities in the aviation industry.",
    thumbnailUrl: [
      "https://mhcockpit.com/Media/Home/Converted/home-video_thumbnail.webp",
    ],
    uploadDate: UPLOAD_DATE,
    contentUrl: "https://mhcockpit.com/Media/Home/home-video.mp4",
    embedUrl: "https://mhcockpit.com/",
    publisher: PUBLISHER,
    potentialAction: watchAction("https://mhcockpit.com/"),
  },

  "/innovation/flight-simulator": trainingVideo({
    name: "Flight Simulator Training at MH Cockpit",
    description:
      "Experience advanced flight simulator training at MH Cockpit. Explore immersive aviation training technology designed to help aspiring pilots develop practical flying skills in a realistic environment.",
    thumbnailUrl:
      "https://mhcockpit.com/Media/Videos/Flight%20Simulator/flight-simulator-thumbnail.webp",
    contentUrl:
      "https://mhcockpit.com/Media/Videos/Flight%20Simulator/Website%20-%20Flight%20Simulator.mp4",
    embedUrl: "https://mhcockpit.com/innovation/flight-simulator",
  }),

  "/training/mba-aviation-and-airport-management": trainingVideo({
    name: "MBA Aviation and Airport Management",
    description:
      "Learn about the MBA Aviation and Airport Management program at MH Cockpit. Explore career opportunities, curriculum highlights, industry exposure, and aviation management training.",
    thumbnailUrl:
      "https://mhcockpit.com/Media/Videos/Training/MBA-FINAL-OUT-NEW-thumbnail.webp",
    contentUrl:
      "https://mhcockpit.com/Media/Videos/Training/MBA%20FINAL%20OUT_NEW.mp4",
    embedUrl:
      "https://mhcockpit.com/training/mba-aviation-and-airport-management",
  }),

  "/training/bba-aviation-management": trainingVideo({
    name: "BBA Aviation Management",
    description:
      "Explore the BBA Aviation Management program at MH Cockpit. Learn about aviation operations, airline management, airport administration, and career opportunities in the aviation industry.",
    thumbnailUrl:
      "https://mhcockpit.com/Media/Videos/Training/bba-aviation-management-thumbnail.webp",
    contentUrl:
      "https://mhcockpit.com/Media/Videos/Training/BBA%20AVIATIOn.mp4",
    embedUrl: "https://mhcockpit.com/training/bba-aviation-management",
  }),

  "/training/type-rating": trainingVideo({
    name: "Type Rating Training Program",
    description:
      "Learn about Type Rating training at MH Cockpit. Explore aircraft-specific pilot training, simulator sessions, airline readiness preparation, and career advancement opportunities for commercial pilots.",
    thumbnailUrl:
      "https://mhcockpit.com/Media/Videos/Training/type-rating-thumbnail.webp",
    contentUrl:
      "https://mhcockpit.com/Media/Videos/Training/Type%20Rating.mp4.mp4",
    embedUrl: "https://mhcockpit.com/training/type-rating",
  }),

  "/training/certification-in-airport-management": trainingVideo({
    name: "Certification in Airport Management",
    description:
      "Learn about the Certification in Airport Management program at MH Cockpit. Explore airport operations, aviation management, industry exposure, and career opportunities in the aviation sector.",
    thumbnailUrl:
      "https://mhcockpit.com/Media/Videos/Training/certification-in-airport-management-thumbnail.webp",
    contentUrl:
      "https://mhcockpit.com/Media/Videos/Training/PG%20Diploma%20in%20AME.mp4",
    embedUrl:
      "https://mhcockpit.com/training/certification-in-airport-management",
  }),

  "/blogs/emerging-technologies-in-aviation-vr-ar": {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    name: "Emerging Technologies in Aviation: VR and AR",
    description:
      "Explore how Virtual Reality (VR) and Augmented Reality (AR) are transforming pilot training, aircraft maintenance, aviation education, and operational efficiency in the aviation industry.",
    thumbnailUrl: ["https://i.ytimg.com/vi/rd2cVVxM0U0/maxresdefault.jpg"],
    uploadDate: UPLOAD_DATE,
    embedUrl: "https://www.youtube.com/embed/rd2cVVxM0U0",
    publisher: PUBLISHER,
    potentialAction: watchAction(
      "https://mhcockpit.com/blogs/emerging-technologies-in-aviation-vr-ar"
    ),
    isFamilyFriendly: true,
    inLanguage: "en-IN",
  },

  "/blogs/emerging-technologies-in-aviation": {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    name: "Emerging Technologies in Aviation: VR and AR",
    description:
      "Explore how Virtual Reality (VR) and Augmented Reality (AR) are transforming pilot training, aircraft maintenance, aviation education, and operational efficiency in the aviation industry.",
    thumbnailUrl: ["https://i.ytimg.com/vi/rd2cVVxM0U0/maxresdefault.jpg"],
    uploadDate: UPLOAD_DATE,
    embedUrl: "https://www.youtube.com/embed/rd2cVVxM0U0",
    publisher: PUBLISHER,
    potentialAction: watchAction(
      "https://mhcockpit.com/blogs/emerging-technologies-in-aviation"
    ),
    isFamilyFriendly: true,
    inLanguage: "en-IN",
  },

  "/training/bsc-aviation": trainingVideo({
    name: "B.Sc Aviation",
    description:
      "Learn about the B.Sc Aviation program at MH Cockpit. Explore aviation operations, airport management, airline procedures, practical industry exposure, and career opportunities in the aviation sector.",
    thumbnailUrl:
      "https://mhcockpit.com/Media/Videos/Training/bsc-aviation-thumbnail.webp",
    contentUrl:
      "https://mhcockpit.com/Media/Videos/Training/B.Sc%20Aviation%202.mp4.mp4",
    embedUrl: "https://mhcockpit.com/training/bsc-aviation",
  }),

  "/training/bsc-aeronautical-science": trainingVideo({
    name: "B.Sc Aeronautical Science",
    description:
      "Learn about the B.Sc Aeronautical Science program at MH Cockpit. Explore aircraft systems, aerodynamics, aviation technology, practical industry exposure, and career opportunities in the aviation sector.",
    thumbnailUrl:
      "https://mhcockpit.com/Media/Videos/Training/bsc-aeronautical-science-thumbnail.webp",
    contentUrl:
      "https://mhcockpit.com/Media/Videos/Training/B.Sc%20Aeronautical%20Science.mp4",
    embedUrl: "https://mhcockpit.com/training/bsc-aeronautical-science",
  }),

  "/training/private-pilot-license": trainingVideo({
    name: "Private Pilot License",
    description:
      "Learn about the Private Pilot License (PPL) program at MH Cockpit. Explore flight training, aviation fundamentals, practical flying experience, and the pathway to becoming a licensed pilot.",
    thumbnailUrl:
      "https://mhcockpit.com/Media/Videos/Training/private-pilot-license-thumbnail.webp",
    contentUrl: "https://mhcockpit.com/Media/Videos/Training/PPL.mp4",
    embedUrl: "https://mhcockpit.com/training/private-pilot-license",
  }),

  "/training/airline-transport-pilot-license": trainingVideo({
    name: "Airline Transport Pilot License",
    description:
      "Learn about the Airline Transport Pilot License (ATPL) program at MH Cockpit. Explore advanced pilot training, airline operations, aviation regulations, flight planning, and career opportunities with commercial airlines.",
    thumbnailUrl:
      "https://mhcockpit.com/Media/Videos/Training/atpl-thumbnail.webp",
    contentUrl:
      "https://mhcockpit.com/Media/Videos/Training/ATPL%20Final%20Out.mp4",
    embedUrl:
      "https://mhcockpit.com/training/airline-transport-pilot-license",
  }),

  "/about-us/our-values": trainingVideo({
    name: "Our Values",
    description:
      "Discover the core values that drive MH Cockpit's commitment to aviation education, professional excellence, innovation, safety, integrity, and student success.",
    thumbnailUrl:
      "https://mhcockpit.com/Media/Videos/Our%20Values/our-values-thumbnail.webp",
    contentUrl:
      "https://mhcockpit.com/Media/Videos/Our%20Values/Our%20Values%20New1.mp4.mp4",
    embedUrl: "https://mhcockpit.com/about-us/our-values",
  }),

  "/training/cabin-crew": trainingVideo({
    name: "Cabin Crew",
    description:
      "Learn about the Cabin Crew program at MH Cockpit. Explore in-flight service, passenger safety, aviation hospitality, emergency procedures, and career opportunities with leading airlines.",
    thumbnailUrl:
      "https://mhcockpit.com/Media/Videos/Training/cabin-crew-thumbnail.webp",
    contentUrl:
      "https://mhcockpit.com/Media/Videos/Training/B.Sc%20Aeronautical%20Science.mp4",
    embedUrl: "https://mhcockpit.com/training/cabin-crew",
  }),

  "/training/bba-aviation-and-ground-handling": trainingVideo({
    name: "BBA Aviation and Ground Handling",
    description:
      "Learn about the BBA Aviation and Ground Handling program at MH Cockpit. Explore aviation operations, airport ground services, airline management, passenger handling, and career opportunities in the aviation industry.",
    thumbnailUrl:
      "https://mhcockpit.com/Media/Videos/Training/bba-aviation-and-ground-handling-thumbnail.webp",
    contentUrl:
      "https://mhcockpit.com/Media/Videos/Training/BBA%20AVIATIOn.mp4",
    embedUrl:
      "https://mhcockpit.com/training/bba-aviation-and-ground-handling",
  }),

  "/innovation/fixed-wing": trainingVideo({
    name: "Fixed Wing Training",
    description:
      "Discover Fixed Wing training at MH Cockpit. Learn about aircraft operations, flight principles, aviation technology, and practical training opportunities designed for aspiring aviation professionals.",
    thumbnailUrl:
      "https://mhcockpit.com/Media/Videos/Fixed%20Wing/fixed-wing-thumbnail.webp",
    contentUrl:
      "https://mhcockpit.com/Media/Videos/Fixed%20Wing/ELECTRIC%20AIRCRAFT%20VIDEO%20converted.mp4",
    embedUrl: "https://mhcockpit.com/innovation/fixed-wing",
  }),

  "/technology/vr-ar-lms": {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    "@id": "https://mhcockpit.com/technology/vr-ar-lms#video",
    name: "VR/AR LMS | Immersive Aviation Training | MH Cockpit",
    description:
      "VR/AR LMS brings virtual experiments, interactive 3D models, and AR experiences together with assessments and progress tracking for aviation learners.",
    thumbnailUrl:
      "https://mhcockpit.com/Media/technology/vrar-lms-combines-immersive-technology.webp",
    uploadDate: "2026-09-24T00:00:00+05:30",
    duration: "PT19S",
    contentUrl:
      "https://mhcockpit.com/Media/technology/vr-ar-aviationvideo.mp4",
    embedUrl: "https://mhcockpit.com/technology/vr-ar-lms",
    width: 1484,
    height: 826,
    publisher: {
      "@type": "Organization",
      name: "MH Cockpit",
      url: "https://mhcockpit.com",
      logo: {
        "@type": "ImageObject",
        url: "https://mhcockpit.com/MH_Cockpit_TM_LOGO_transparent.png",
        width: 600,
        height: 60,
      },
    },
    "inLanguage": "en-IN",
    "isAccessibleForFree": true,
  },
};

export { LOGO_URL, PUBLISHER, UPLOAD_DATE };
